<template>
  <div class="forgotten-password">
    <div class="forgotten-password__title">
      <h1>{{ $t('recoverPassword.title') }}</h1>
    </div>
    <el-form class="forgotten-password__form"
      :model="form"
      :rules="rules"
      @submit.native.prevent="submit"
      ref="form">
      <el-form-item
        :label="$t('recoverPassword.email')"
        class="forgotten-password__form__input"
        prop="email">
        <el-input
          :placeholder="$t('recoverPassword.email')"
          autofocus
          v-model="form.email"
          suffix-icon="el-icon-message">
        </el-input>
      </el-form-item>
      <el-form-item class="forgotten-password__form__submit">
        <el-button
          :loading="isRecoverPasswordLoading"
          :disabled="isRecoverPasswordLoading"
          native-type="submit"
          type="primary"
          class="forgotten-password__form__submit--btn">
          {{ $t('recoverPassword.submit') }}
        </el-button>
      </el-form-item>
      <div class="forgotten-password__form__login">
        <router-link
          :to="{ name: 'login'}"
          tabindex="-1"
          class="forgotten-password__form__login--link el-link el-link--primary is-underline">
          <span class="el-link--inner">{{ $t('recoverPassword.login') }}</span>
        </router-link>
      </div>
      <div class="forgotten-password__form__register" v-if="isRegisterPossible">
        <p>{{ $t('recoverPassword.registerText') }}
          <el-link
            type="primary"
            href="#"
            class="forgotten-password__form__register--link">
            {{ $t('recoverPassword.registerBtn') }}
          </el-link>
        </p>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import logoNextories from '@/assets/img/logo-nextories.png';

export default {
  name: 'recoverPassword',
  data() {
    return {
      form: {
        email: '',
      },
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('recoverPassword.emailWarning'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isRecoverPasswordLoading: 'authStore/isRecoverPasswordLoading',
    }),
    logo() {
      return logoNextories;
    },
    isRegisterPossible() {
      return process.env.VUE_APP_REGISTER !== 'false';
    },
  },
  methods: {
    ...mapActions({
      recoverPassword: 'authStore/recoverPassword',
    }),
    submit() {
      this.$refs.form.validate(async (valid) => {
        try {
          if (valid) {
            await this.recoverPassword({ email: this.form.email });
            this.$router.push({
              name: 'login',
            });
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters['authStore/isLogged']) {
      return next();
    }
    if (to.query.u) {
      return next(decodeURIComponent(to.query.u));
    }
    return next({ name: 'home' });
  },
};
</script>

<style scoped lang="scss">

.forgotten-password {
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
  @include breakpoint(desktop) {
    padding: 0;
    margin-top: 8rem;
  }
  &__form {
    margin: 20px 0;
    &__input {
      :deep(.el-form-item__label) {
        font-size: 18px;
      }
    }
    &__login {
      text-align: right;
      margin-top: 10px;
      &--link {
        font-size: 16px;
        vertical-align: top;
      }
    }
    &__submit {
      margin-top: 50px;
      margin-bottom: 0;
      &--btn {
        width: 100%;
        font-weight: 700;
        font-size: 18px;
      }
    }
    &__register {
      &--link {
        font-size: 16px;
        vertical-align: top;
      }
    }
  }
}
</style>
